function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function memoize(method, resolver) {
  let cache = {};

  return async function memoized() {
    let key = resolver
      ? resolver.apply(this, arguments)
      : JSON.stringify(arguments);
    cache[key] = cache[key] || method.apply(this, arguments);
    return cache[key];
  };
}

export { sleep, memoize, Datasource };
